<div class="status-label-container d-flex">
  <div [className]="labelStyle">
    <div *ngIf="statusFound" class="icon"
      [ngStyle]="{'background-color':statusColor, 'border': '2px solid '+ borderColor}"></div>
    <div class="label" [ngClass]="labelClass">{{statusDescription}}</div>
  </div>
</div>